import {
  isMultiSelectElicitation,
  isSingleSelectElicitation,
  type MultiSelectElicitation,
  type RenderableElicitation,
  type SingleSelectElicitation,
} from '~/components/v2/components/workspace/workspace-agent-panel/schemas/elicitation';

/** `UnknownElicitation.type` is `string`, so equality alone won't narrow the union in JSX. */
export const isSelectElicitationEntry = (
  elicitation: RenderableElicitation | null,
): elicitation is SingleSelectElicitation | MultiSelectElicitation =>
  elicitation !== null && (isSingleSelectElicitation(elicitation) || isMultiSelectElicitation(elicitation));
